import React, { useEffect, useState } from 'react';
import './ToggleButton.scss';
type ToggleButtonProps = {
  disabled?: boolean;
  isChecked: boolean;
  onChange: (active: boolean) => void;
  enableTwoWayBinding?: boolean;
};

export const ToggleButton = ({
  enableTwoWayBinding,
  isChecked,
  onChange,
  disabled = false,
}: ToggleButtonProps) => {
  const [checked, setChecked] = useState(true);
  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);
  const onToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    !enableTwoWayBinding && setChecked(event.target.checked);
    onChange(event.target.checked);
  };
  return (
    <div className="toggle-btn-container">
      <label className="switch">
        <input type="checkbox" checked={checked} onChange={onToggleChange} disabled={disabled} />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

ToggleButton.displayName = 'ToggleButton';
